import React from 'react'
import './Title.css'
function Title() {
  return (
    <div className="title">
        <h2>Our maid service aims to delight every time — that’s our promise</h2>
    </div>
  )
}
export default Title